import type { HTMLAttributes, ReactNode } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  action?: ReactNode;
  children: ReactNode;
}

export default function Card({ title, action, children, className = '', ...rest }: Props) {
  return (
    <div
      className={`rounded-lg border bg-card p-5 ${className}`}
      {...rest}
    >
      {(title || action) && (
        <div className="mb-4 flex items-center justify-between gap-3">
          {title && <h3 className="text-sm font-semibold md:text-base">{title}</h3>}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}